import classNames from "classnames";

export default function MultiplicationSymbol({ className }) {
  return (
    <span
      className={classNames(
        "text-2.5xl font-light text-subtext-gray select-none",
        className
      )}
    >
      ×
    </span>
  );
}
